import { FormValidations } from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationService from "features/validation/ValidationService";

export const formValidations = (): FormValidations => {
  return {
    DESC_TMSEZNAMSU: {
      required: true,
      type: "OnlyRequired"
    },
    email: {
      required: true,
      type: "Function",
      validate: (value: any) => new ValidationService().ValidateEmail(value),
      message: "invalidEmail"
    } as FunctionValidationRule
  };
}